import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { CURRENCY, PRICE_AMOUNT, PRICE_BEFORE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/musikkklar';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-241" data-mp="1mmqx21lulfnn">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-242" data-mp="1hp7if0l8n0v6">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-243" data-mp="tzd7iokhbmdk">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-244" data-mp="p0a2v58evi64">
            Oppdag den komplette <em className="text-red-300" data-id="element-245" data-mp="13xaul8qlrd4l">MUSIKK KLAR™</em>-pakken
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-246" data-mp="yy7tfzdqtr1w">
            Hele skoleåret i musikk – ferdig planlagt. Kom i gang på 5 minutter.
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-247" data-mp="2fe0xahvthmtg" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-248" data-mp="pkqq2g8zw5cx">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-249" data-mp="uhh4kz55isw8">Den komplette pakken inneholder</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-250" data-mp="zgagin4sibua">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-251" data-mp="13hnlyw3z0d0o">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-252" data-mp="6v0w1vd23nm2">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-253" data-mp="bt2b857d32s9" />
                </span>
                <span data-id="element-254" data-mp="fskuyxng57ti">
                  <span className="block font-medium leading-snug" data-id="element-255" data-mp="klnt7j3655g1">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-256" data-mp="3k8m43344ej6s">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-257" data-mp="3o8edfi1c8td7">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-258" data-mp="qgxf9xgp4zm8">Introduksjonspris <s className="ml-1 text-slate-900/50" data-id="element-259" data-mp="qete3na6mepn">{PRICE_BEFORE}</s></p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-260" data-mp="1550ln7ynidbk">
              {PRICE_AMOUNT}
              <span className="ml-2 font-sans text-2xl font-semibold tracking-normal text-slate-900/70 sm:text-3xl" data-id="element-261" data-mp="cgv40u2w94fy">{CURRENCY}</span>
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-262" data-mp="7jct4y5bgf5b">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-263" data-mp="lfgiad1c1xax" />
            Engangsbetaling. Ingen abonnement.
          </p>

          <CtaButton label="Skaff hele pakken nå" className="mt-8 w-full" data-id="element-264" data-mp="1wwg9f5by263d" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-265" data-mp="1wysx7z4dvaoc">
            {offerIncludes.map(item => <li key={item} data-id="element-266" data-mp="20e4bdsqoqipm">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}